const Honeybadger = require('honeybadger-js');

angular.module('common').value('$exceptionHandler', function(error) {
  // eslint-disable-next-line no-console
  console.error(error)
  Honeybadger.notify(error)
});
